import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EpErrorService, IconService, ToastService } from '@isophi/core-ui';
import { DistinctionEnum, KindergartenService, OperationTypeEnum } from '@isophi/mng-api';
import { TranslocoService } from '@jsverse/transloco';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, Subscription } from 'rxjs';

import { HelperService } from '../../../../core/services/helper.service';
import { distinctionData, operationTypeData } from './data';

@Component({
  selector: 'app-traffic-form',
  templateUrl: './traffic-form.component.html',
  styleUrls: ['./traffic-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TrafficFormComponent implements OnDestroy {
  private readonly epErrorService = inject(EpErrorService);
  trafficForm: FormGroup;

  kindergartenOperationType: { [key: string]: string }[] = [];

  distinction: { [key: string]: string }[] = [];

  private _subs: Subscription[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private helperService: HelperService,
    private kindergartenService: KindergartenService,
    private spinner: NgxSpinnerService,
    private translocoService: TranslocoService,
    private toastr: ToastService,
    public iconService: IconService
  ) {
    this.kindergartenOperationType = this.helperService.prepareData(operationTypeData, OperationTypeEnum);
    this.distinction = this.helperService.prepareData(distinctionData, DistinctionEnum);

    this.trafficForm = this.formBuilder.group({
      kindergartenOperationType: [null],
      distinction: [null],
      avgFullDayHours: [''],
      avgHalfDayHours: [''],
      avgBoardingHours: [''],
      contactPerson: this.formBuilder.group({
        name: [''],
        email: [''],
        phone: [''],
      }),
    });

    this._subs.push(
      this.kindergartenService.kindergartenDetailRetrieve().subscribe({
        next: (val) => {
          this.trafficForm.patchValue(val);
        },
      })
    );
  }

  onSubmit(): void {
    if (this.trafficForm.valid) {
      this.spinner.show();

      this.kindergartenService
        .kindergartenUpdatePartialUpdate(this.trafficForm.value)
        .pipe(finalize(() => this.spinner.hide()))
        .subscribe({
          next: () => {
            this.toastr.success(
              this.translocoService.translate('settings/trafficSuccess'),
              this.translocoService.translate('settings/traffic')
            );
          },
          error: (e) => {
            this.epErrorService.handleEpErrorResponse(e, this.translocoService.translate('settings/trafficError'));
            this.spinner.hide();
          },
        });
    }
  }

  ngOnDestroy(): void {
    this._subs.forEach((_sub) => _sub.unsubscribe());
  }
}
